import { DCUIContent } from "@iddataweb/idw-common-ui/types";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { DCUIThemingStep } from "@idw-types/common/dcui/dcui-theming-step";
import { DCUIThemingStartPageValidationErrors } from "@idw-types/common/validation/common/dcui-theming-validation-errors";
import { DCUIThemingStartPageCaptureStepContainer } from "./dcui-theming-start-page-capture-step-container/dcui-theming-start-page-capture-step-container";
import { PageLevelTypes } from "@enums/page-level-types";

type DCUIThemingStartPageCaptureStepsSectionProps = {
    layout: LayoutTypes;
    labelWidth: LabelWidthTypes;
    isDisabled: boolean;
    dcuiContent: DCUIContent;
    inheritedDCUIContent: DCUIContent;
    uploadFileToS3: (file: File, category: string) => Promise<string>;
    pageLevel: PageLevelTypes;
    validationErrors: DCUIThemingStartPageValidationErrors;
    documentCaptureSteps: Array<DCUIThemingStep>;
    updateDCUIContentPropertyValue: (dcuiContent: DCUIContent) => void;
};

export const DCUIThemingStartPageCaptureStepsSection = (props: DCUIThemingStartPageCaptureStepsSectionProps) => {
    const {
        layout,
        labelWidth,
        isDisabled,
        dcuiContent,
        inheritedDCUIContent,
        uploadFileToS3,
        pageLevel,
        validationErrors,
        documentCaptureSteps,
        updateDCUIContentPropertyValue
    } = props;

    return (
        <div>
            {documentCaptureSteps.map(captureStep => (
                <DCUIThemingStartPageCaptureStepContainer
                    key={`dcui-theming-start-page-${captureStep.stepType}-capture-step`}
                    isDisabled={isDisabled}
                    dcuiContent={dcuiContent}
                    inheritedDCUIContent={inheritedDCUIContent}
                    uploadFileToS3={uploadFileToS3}
                    pageLevel={pageLevel}
                    layout={layout}
                    labelWidth={labelWidth}
                    validationErrors={validationErrors[captureStep.stepType]}
                    stepResources={captureStep.stepResources}
                    stepType={captureStep.stepType}
                    updateDCUIContentPropertyValue={updateDCUIContentPropertyValue}
                />
            ))}
        </div>
    );
};